import { createSelector } from 'reselect'

const qsSelector = state => state.qs

export default createSelector(
	[qsSelector],
	qsSelectorData => ({
		lcsbt: qsSelectorData.lcsbt || '',
		sk: qsSelectorData.sk || '',
	})
)
